"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantProfileModalView = ApplicantProfileModalView;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const icons_1 = require("@ant-design/icons");
const ApplicantResumeWebViewMain_1 = require("@src/components/pages/profile/modules/resume/web-view/ApplicantResumeWebViewMain");
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
const download_applicant_profile_1 = require("@src/helpers/download-applicant-profile");
const localized_path_1 = require("@src/shared/localized-path");
const styled_components_1 = __importStar(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const antd_1 = require("antd");
const react_use_1 = require("react-use");
const BlackTextLink = styled_components_1.default.a `
	&& {
		color: rgba(0, 0, 0, 0.85);
		&:hover {
			color: #4a1c56;
		}
	}
`;
const BackArrowButton = ({ setShowProfileInModal }) => ((0, jsx_runtime_1.jsx)(elements_1.Button, { type: "default", size: "middle", icon: (0, jsx_runtime_1.jsx)(icons_1.ArrowLeftOutlined, { className: "m-r-s" }), onClick: () => setShowProfileInModal(false), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.hiring_process.detail.back" }) }));
const DrawerWrapper = (0, styled_components_1.default)(antd_1.Drawer) `
	${({ visible }) => visible &&
    (0, styled_components_1.css) `
			&& {
				z-index: ${props => props.theme.zIndex.drawer + 1} !important;
				width: 100% !important;
				.ant-drawer-content-wrapper {
					width: 480px !important;

					${(0, styled_breakpoints_1.down)('xs')} {
						width: 100% !important;
					}
				}
			}
		`}
`;
const ApplicantComboButton = ({ applicantProfileUuid, intl }) => {
    const locale = typeof window !== 'undefined' ? (0, localized_path_1.getLanguageFromPathname)(window.location.pathname) : 'sk';
    const localizedPath = (0, localized_path_1.getLocalizedPath)(`/admin/uchadzaci/pouzivatel/${applicantProfileUuid}`, locale);
    return ((0, jsx_runtime_1.jsxs)(elements_1.ComboButton, { type: "default", onClick: () => (0, download_applicant_profile_1.downloadProfile)(applicantProfileUuid, intl), menu: [
            {
                label: ((0, jsx_runtime_1.jsx)(BlackTextLink, { href: localizedPath, target: "_blank", rel: "noopener, noreferrer", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.hiring_process.detail.open_in_new_tab" }) })),
            },
        ], children: [(0, jsx_runtime_1.jsx)(icons_1.FilePdfOutlined, {}), (0, jsx_runtime_1.jsx)("span", { className: "m-l-s", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.download_pdf" }) })] }));
};
function ApplicantProfileModalView({ applicantProfileUuid, visible, setShowProfileInModal, setApplicationDetail, }) {
    const [isInitialized, setIsInitialized] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    const [ref, { width }] = (0, react_use_1.useMeasure)();
    react_1.default.useEffect(() => {
        setIsInitialized(true);
    }, []);
    if (!isInitialized) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(DrawerWrapper, { placement: "left", visible: visible, closable: false, mask: true, maskStyle: { opacity: 0, animation: 'none' }, onClose: () => {
            setApplicationDetail(null);
            setShowProfileInModal(false);
        }, maskClosable: true, title: (0, jsx_runtime_1.jsxs)("div", { className: "flex-row justify-space-between align-center", children: [(0, jsx_runtime_1.jsx)(BackArrowButton, { setShowProfileInModal: setShowProfileInModal }), (0, jsx_runtime_1.jsx)(ApplicantComboButton, { intl: intl, applicantProfileUuid: applicantProfileUuid })] }), children: (0, jsx_runtime_1.jsx)("div", { ref: () => ref, children: (0, jsx_runtime_1.jsx)(ApplicantResumeWebViewMain_1.ApplicantResumeWebViewMain, { mainWidth: width, applicantProfileUuid: applicantProfileUuid }) }) }));
}
